var _circle, _path, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGood = function SvgGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFCC4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M10.52 23.62C10.55 23.8 11.68 28 18 28s7.44-4.2 7.49-4.38a.5.5 0 0 0-.24-.55.5.5 0 0 0-.6.07C24.63 23.16 22.69 25 18 25s-6.63-1.84-6.65-1.85a.5.5 0 0 0-.6-.09.5.5 0 0 0-.24.56z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5,
    fill: "#664500",
    rx: 2.5,
    ry: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 13.5,
    fill: "#664500",
    rx: 2.5,
    ry: 3.5
  })));
};
export default SvgGood;